var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4873 9.10691C10.1836 8.80317 10.1836 8.31071 10.4873 8.00697L12.7151 5.77915L1.25952 5.77915C0.829968 5.77915 0.481744 5.43093 0.481744 5.00138C0.481744 4.57182 0.829967 4.2236 1.25952 4.2236L12.7151 4.2236L10.4873 1.9958C10.1836 1.69206 10.1836 1.1996 10.4873 0.895856C10.7911 0.592114 11.2835 0.592114 11.5873 0.895856L14.5143 3.82287L14.0383 4.2989L14.5143 3.82287C15.1652 4.47374 15.1652 5.52902 14.5143 6.17989L11.5873 9.10691C11.2835 9.41065 10.7911 9.41065 10.4873 9.10691Z",
    fill: "#28303F"
  })));
};
export default SvgArrow;